import { toSkillSlug } from '@/app-shell/rpa/recorder/lib/skill-slug';
import type { SkillSummary } from '@/app-shell/rpa/recorder/types/skill-summary';
import type { WorkflowSkill } from '@/app-shell/rpa/recorder/types/workflow';

export function deriveAvailableWorkflowSkillsFromSummaries(
  summaries: readonly SkillSummary[]
): readonly WorkflowSkill[] {
  return summaries.flatMap((summary) =>
    summary.status === 'ready' && summary.skillId
      ? [
          {
            skillId: summary.skillId,
            recordingId: summary.recordingId,
            slug: toSkillSlug(summary.title),
            title: summary.title,
          },
        ]
      : []
  );
}
